import FormElementAutocompleteMixin from '../mixins/FormElementAutocompleteMixin.js';

Vue.asyncComponent('ak-autocomplete', {
    mixins: [FormElementAutocompleteMixin],
    props: {
        filterMethode: {
            required: false,
        },
        minCharCount: {
            type: Number,
            required: false,
            default: 3
        }
    },

}, 'form/controls/ak-autocomplete.html');